module.exports = __webpack_public_path__ + "img/logo_white.cd8d1d0.png";